import {
  UPDATE_VISITOR_KEYS_DATA_FAILURE,
  UPDATE_VISITOR_KEYS_DATA_REQUESTED,
  UPDATE_VISITOR_KEYS_DATA_SUCCESS,
  VISITOR_KEYS_BUILDINGS_FAILURE,
  VISITOR_KEYS_BUILDINGS_REQUESTED,
  VISITOR_KEYS_BUILDINGS_SUCCESS,
  VISITOR_KEYS_DATA_FAILURE,
  VISITOR_KEYS_DATA_REQUESTED,
  VISITOR_KEYS_DATA_SUCCESS,
} from '../../../actionConstants';

import apiClient from '../../../apiClient';

const getBuildings = (dispatch) => {
  dispatch({
    type: VISITOR_KEYS_BUILDINGS_REQUESTED,
    payload: apiClient.visitorKeysData.getAll().then(
      (res) =>
        dispatch({
          type: VISITOR_KEYS_BUILDINGS_SUCCESS,
          res,
        }),
      (err) =>
        dispatch({
          type: VISITOR_KEYS_BUILDINGS_FAILURE,
          err,
        }),
    ),
  });
};

const getVisitorKeysData = (dispatch, id) => {
  dispatch({
    type: VISITOR_KEYS_DATA_REQUESTED,
    payload: apiClient.visitorKeysData.get(id).then(
      (res) =>
        dispatch({
          type: VISITOR_KEYS_DATA_SUCCESS,
          res,
        }),
      (err) =>
        dispatch({
          type: VISITOR_KEYS_DATA_FAILURE,
          err,
        }),
    ),
  });
};

const putVisitorKeysData = (dispatch, data, saveChangesUserMade) =>
  dispatch({
    type: UPDATE_VISITOR_KEYS_DATA_REQUESTED,
    payload: apiClient.visitorKeysData.put(data),
  }).then(
    (res) => {
      if (saveChangesUserMade) {
        getVisitorKeysData(dispatch, data.buildings[0]);
      }
      return dispatch({
        type: UPDATE_VISITOR_KEYS_DATA_SUCCESS,
        res,
      });
    },
    (err) =>
      dispatch({
        type: UPDATE_VISITOR_KEYS_DATA_FAILURE,
        err,
      }),
  );

export { getVisitorKeysData, putVisitorKeysData, getBuildings };
